export default "__VITE_ASSET__DSn5nOy4__"